<button *ngIf="data.config.closeButton" mat-icon-button appDialogClose class="color-secondary close-button">
  <svg-icon key="close"></svg-icon>
</button>
<ng-template cdkPortalOutlet></ng-template>
